/**
 * Created by slava on 15/8/19
 */

const CrazyCombosLibrary = {
    merge: function (cells, mergeConstructor, callback) {
        const shape = new Shape(cells);

        const duration = this.getMergeDuration();

        const center = shape.getCenter();
        shape.merge({
            target: center,
            duration
        });

        const superCell = mergeConstructor(center);

        Game.currentGame.counter.setTimeout(() => {
            cells.forEach((cell) => {
                cell.delete();
            });

            Game.currentGame.field.addCell(superCell);
            superCell.animate(BaseCell.ANIMATION_CREATE);

            Game.currentGame.counter.setTimeout(() => {
                callback(superCell);
            }, superCell.beforeExplodeTimeout() * 1000);
        }, duration * 1000);
    },

    getMergeDuration: function () {
        return 0.2;
    },

    multicolorSimple: function (multicolor, other) {
        multicolor.crazyActionSimple(other);
    },

    multicolorCombo: function (multicolor, other) {
        if (other instanceof ComboCell) {
            const shape = new Shape([multicolor, other]);

            const duration = this.getMergeDuration();

            const center = shape.getCenter();
            shape.merge({
                target: center,
                duration
            });

            Game.currentGame.counter.setTimeout(() => {
                other.delete();
                Game.currentGame.field.removeCell(other.x, other.y);

                multicolor.crazyActionDuplicateCombos(other, () => {
                    const combo = new ComboCell(multicolor.x, multicolor.y, {
                        algo: other.algo
                    });
                    Game.currentGame.field.addCell(combo);
                    combo.animate(BaseCell.ANIMATION_SHOWUP, { silent: true });
                    combo.explode();
                });
            }, duration * 1000);
        } else {
            multicolor.crazyActionDuplicateCombos(other);
        }
    },

    multicolorTwo: function (start, finish) {
        CrazyCombosLibrary.merge([start, finish], (center) => new SuperMultiColorCell(center.x, center.y), (superCell) => {
            superCell.explode();
        });
    },

    planeTwo: function (start, finish) {
        CrazyCombosLibrary.merge([start, finish], (center) => {
            const key = `${CombosLibrary.TYPE_PLANE}_${CombosLibrary.TYPE_PLANE}`;
            return new ComboCell(center.x, center.y, {
                algo: { ...CombosLibrary.ByShape[Shape.PLANE], ...CombosLibrary.powerUp[key] }
            });
        }, (superCell) => {
            [start, finish].forEach((cell) => {
                if (!(cell.x === superCell.x && cell.y === superCell.y)) {
                    Game.currentGame.field.removeCell(cell.x, cell.y);
                }
            });

            superCell.explode();
        });
    },

    planeLiner: function (start, finish) {
        let cargo;

        [start, finish].forEach((cell) => {
            if (cell.algo.name === CombosLibrary.TYPE_LINER) {
                cargo = cell.algo;
            }
        });

        CrazyCombosLibrary.merge([start, finish], (center) => {
            const key = `${CombosLibrary.TYPE_PLANE}_${CombosLibrary.TYPE_LINER}`;
            return new ComboCell(center.x, center.y, {
                algo: { cargo, ...CombosLibrary.ByShape[Shape.PLANE], ...CombosLibrary.powerUp[key] }
            });
        }, (superCell) => {
            [start, finish].forEach((cell) => {
                if (!(cell.x === superCell.x && cell.y === superCell.y)) {
                    Game.currentGame.field.removeCell(cell.x, cell.y);
                }
            });

            superCell.explode();
        });
    },

    planeBomb: function (start, finish) {
        let cargo;

        [start, finish].forEach((cell) => {
            if (cell.algo.name === CombosLibrary.TYPE_BOMB) {
                cargo = cell.algo;
            }
        });

        CrazyCombosLibrary.merge([start, finish], (center) => {
            const key = `${CombosLibrary.TYPE_PLANE}_${CombosLibrary.TYPE_BOMB}`;
            return new ComboCell(center.x, center.y, {
                algo: { cargo, ...CombosLibrary.ByShape[Shape.PLANE], ...CombosLibrary.powerUp[key] }
            });
        }, (superCell) => {
            [start, finish].forEach((cell) => {
                if (!(cell.x === superCell.x && cell.y === superCell.y)) {
                    Game.currentGame.field.removeCell(cell.x, cell.y);
                }
            });

            superCell.explode();
        });
    },

    linerTwo: function (start, finish) {
        CrazyCombosLibrary.merge([start, finish], (center) => {
            const key = `${CombosLibrary.TYPE_LINER}_${CombosLibrary.TYPE_LINER}`;
            const comboCell = new ComboCell(center.x, center.y, {
                algo: { name: CombosLibrary.TYPE_LINER, ...CombosLibrary.Liner, ...CombosLibrary.powerUp[key] }
            });
            comboCell.addComponent(SuperLinerComponent);
            return comboCell;
        }, (superCell) => {
            [start, finish].forEach((cell) => {
                if (!(cell.x === superCell.x && cell.y === superCell.y)) {
                    Game.currentGame.field.removeCell(cell.x, cell.y);
                }
            });

            superCell.explode();
        });
    },

    linerBomb: function (start, finish) {
        CrazyCombosLibrary.merge([start, finish], (center) => {
            const key = `${CombosLibrary.TYPE_LINER}_${CombosLibrary.TYPE_BOMB}`;
            const comboCell = new ComboCell(center.x, center.y, {
                algo: { name: CombosLibrary.TYPE_SUPER_LINER, ...CombosLibrary.Liner, ...CombosLibrary.powerUp[key] }
            });
            comboCell.addComponent(SuperLinerComponent);
            return comboCell;
        }, (superCell) => {
            [start, finish].forEach((cell) => {
                if (!(cell.x === superCell.x && cell.y === superCell.y)) {
                    Game.currentGame.field.removeCell(cell.x, cell.y);
                }
            });

            superCell.explode();
        });
    },

    bombBomb: function (start, finish) {
        CrazyCombosLibrary.merge([start, finish], (center) => {
            const key = `${CombosLibrary.TYPE_BOMB}_${CombosLibrary.TYPE_BOMB}`;
            return new ComboCell(center.x, center.y, {
                algo: { ...CombosLibrary.ByShape[Shape.BOMB], ...CombosLibrary.powerUp[key] }
            });
        }, (superCell) => {
            [start, finish].forEach((cell) => {
                if (!(cell.x === superCell.x && cell.y === superCell.y)) {
                    Game.currentGame.field.removeCell(cell.x, cell.y);
                }
            });

            superCell.explode();
        });
    },

    comboCombo: function (start, finish) {
        if (Match3Rules.Heroes) {
            if (Game.currentGame && !Game.currentGame.field.isThreeInRow(start.y, start.x)) {
                start.mustHurtNextBurn = true;
            }

            if (Game.currentGame && !Game.currentGame.field.isThreeInRow(finish.y, finish.x)) {
                finish.mustHurtNextBurn = true;
            }

            return;
        }

        const match = function (typeA, typeB) {
            return start.algo.name === typeA && finish.algo.name === typeB || start.algo.name === typeB && finish.algo.name === typeA;
        };

        if (match(CombosLibrary.TYPE_PLANE, CombosLibrary.TYPE_PLANE)) {
            CrazyCombosLibrary.planeTwo(start, finish);
        } else if (match(CombosLibrary.TYPE_PLANE, CombosLibrary.TYPE_LINER)) {
            CrazyCombosLibrary.planeLiner(start, finish);
        } else if (match(CombosLibrary.TYPE_PLANE, CombosLibrary.TYPE_BOMB)) {
            CrazyCombosLibrary.planeBomb(start, finish);
        } else if (match(CombosLibrary.TYPE_LINER, CombosLibrary.TYPE_LINER)) {
            CrazyCombosLibrary.linerTwo(start, finish);
        } else if (match(CombosLibrary.TYPE_LINER, CombosLibrary.TYPE_BOMB)) {
            CrazyCombosLibrary.linerBomb(start, finish);
        } else if (match(CombosLibrary.TYPE_BOMB, CombosLibrary.TYPE_BOMB)) {
            CrazyCombosLibrary.bombBomb(start, finish);
        }
    },

    colorCombo: function (color, combo) {
        if (Match3Rules.Heroes) {
            return;
        }

        combo.mustHurtNextBurn = true;
    }
};

const CrazyCombos = function (start, finish) {
    if (start instanceof MultiColorCell || finish instanceof MultiColorCell) {
        if (start instanceof MultiColorCell && finish instanceof MultiColorCell) {
            CrazyCombosLibrary.multicolorTwo(start, finish);
        } else {
            let multicolor = start;
            let other = finish;

            if (finish instanceof MultiColorCell) {
                multicolor = finish;
                other = start;
            }

            if (other.findComponent(ComboComponent)) {
                CrazyCombosLibrary.multicolorCombo(multicolor, other);
            } else {
                CrazyCombosLibrary.multicolorSimple(multicolor, other);
            }
        }
    } else if (start.findComponent(ComboComponent) && finish.findComponent(ComboComponent)) {
        CrazyCombosLibrary.comboCombo(start, finish);
    } else if (start.findComponent(ComboComponent) && finish.findComponent(ColorComponent)) {
        CrazyCombosLibrary.colorCombo(finish, start);
    } else if (finish.findComponent(ComboComponent) && start.findComponent(ColorComponent)) {
        CrazyCombosLibrary.colorCombo(start, finish);
    }
};